import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for generating tokens with filters.
 */
export default class FilterGenerateTokenView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing a date picker
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date picker
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Right section (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Additional right section (currently empty)
        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section layout combining left and a spacer
        const upper_section = {
            cols: [
                center_left,
                { gravity: 1, minWidth: 10 }, // Spacer
            ],
        };

        // Button configuration section
        const buttons = {
            margin: 0,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Crear Token Personalizado'), // Button label
                    width: 120,
                    hidden: !devConfig.getPermAction(
                        'betShopConfigurationGenerateTokenAdd',
                        'Add', // Permission check for button visibility
                    ),
                    css: 'prm-betShopConfigurationGenerateTokenAdd',
                    click: () => {
                        this.app.callEvent('createToken:button', [[]]); // Event call on button click
                    },
                },
                {
                    view: 'button',
                    value: _('Generar Token'), // Button label
                    width: 120,
                    hidden: !devConfig.getPermAction(
                        'betShopConfigurationGenerateTokenAdd',
                        'Add', // Permission check for button visibility
                    ),
                    css: 'prm-betShopConfigurationGenerateTokenAdd',
                    click: () => {
                        const cur_user = this.getParam('user', true); // Get current user parameter
                        const filterdata = this.getRoot().getValues(); // Get form values
                        var thisClich = this; // Reference to the current context
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type for AJAX request
                            })
                            .post(
                                devConfig.geturlApi() + '/UserManagement/SaveUserSecurity', // API endpoint
                                '{ "UserId":' + cur_user + '}', // Request body
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error')); // Error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse response
                                        webix.message(_('Guardado')); // Success message
                                        thisClich.app.callEvent(
                                            'generateTokenBetShop:filter',
                                            [filterdata], // Trigger filter event
                                        );
                                    },
                                },
                            );
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Button label
                    width: 66,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button label
                    hotkey: 'enter', // Shortcut key
                    type: 'form',
                    width: 84,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('generateTokenBetShop:filter', [
                            filterdata, // Trigger filter event
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current context

        // Popup window configuration for creating a token
        var popupAdd = webix.ui({
            view: 'window',
            id: 'CreateToken',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Crear Token') }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup on icon click
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Make the popup modal
            body: {
                view: 'form',
                id: 'addform',
                elements: [
                    {
                        view: 'combo',
                        label: _('Tipo'), // Combo box label
                        name: 'Type',
                        options: [{ id: '2', value: _('Box') }], // Combo options
                        required: true, // Required field
                    },
                    {
                        view: 'textarea',
                        name: 'Token',
                        label: _('Token'), // Textarea label
                        labelPosition: 'top',
                        placeholder: _('Token'), // Placeholder text
                        required: true, // Required field
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    this.getTopParentView().hide(); // Close popup on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    const cur_user = vthis.getParam(
                                        'user',
                                        true, // Get current user parameter
                                    );
                                    var vthis2 = this; // Reference to the current context
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for AJAX request
                                            })
                                            .post(
                                                devConfig.geturlApi() + '/UserManagement/SaveUserSecurityTokenCustom', // API endpoint
                                                '{"UserId":"' +
                                                    cur_user +
                                                    '","Type":"' +
                                                    values.Type +
                                                    '", "Token":"' +
                                                    values.Token +
                                                    '"}', // Request body
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            _('Token Creado'), // Success message
                                                        );
                                                        $$('addform').setValues(
                                                            $$('addform').getCleanValues(), // Reset form values
                                                        );
                                                        vthis2.getTopParentView().hide(); // Close popup
                                                    },
                                                },
                                            );
                                    } else {
                                        webix.message({
                                            title: '¡Error!',
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Validation error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate fields on change
                        },
                    },
                },
            },
        });

        // Event listener for creating a token
        this.on(this.app, 'createToken:button', (filter) => {
            popupAdd.show(); // Show the popup
            $$('addform').clearValidation(); // Clear validation messages
        });
    }
}

// FILE DOCUMENTED
